export default "__VITE_ASSET__SsVsMNsn__"